<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div
        class="content content-pd"
        v-loading.fullscreen.lock="loading"
      >
        <!-- <div class="main-title pd">{{ content.menu_title }}</div> -->
        <!-- <div class="main-sub pd" v-html="content.title_brief"></div> -->
        <div class="fir_box">
          <span>责任通知</span>
          <el-image
            :src="stepImg"
           class="zrtz"
          ></el-image>
        </div>
        <div class="duty-wrap">
        
          <div
            class="template-list"
            v-for="(item, index) in fileList"
            :key="index"
          >
            <el-image class="file-icon" :src="fileIcon" fit="cover"></el-image>
            <div class="te-left">
              <p class="file-name">{{ item.name }}</p>
              <p class="file-time">上传时间：{{ item.inputtime }}</p>
              <p class="file-num">已下载 {{ item.downloadNum }} 次</p>
            </div>
            <div class="te-right" @click="down(item.file, item.name, item.id)">
              <!-- <span>打印</span> -->
              <span>下载</span>
            </div>
          </div>
          <div class="duty-tips">
            下载《责任通知书》并打印，签字盖章后将所有页面拍照上传
          </div>
        </div>
        <div class="upload-duty pd">
               <div class="upload-morewrap">
            <!-- :on-preview="handlePictureCardPreview" -->
            <el-upload
              class="upload-demo"
              list-type="picture-card"
              :action="$Url"
              :headers="headers"
              multiple
              name="file"
              :file-list="dutyImgs"
              :limit="5"
              :on-remove="handleRemove"
              :on-success="handlePictureSuccess"
              :class="fileLength === 5 ? 'hide-box' : ''"
            >
              <i class="el-icon-tickets"></i>
              <div class="el-upload__text">
                <p style="color: #000; font-size: 16px">上传责任通知书</p>
                <p>支持.jpg .png等格式</p>
              </div>
            </el-upload>
          </div>
          <!-- <div>
            上传盖章后的责任通知书
            <span class="edit-btn" @click="isShowUploadImage = true"
              >上传/编辑</span
            >
            <span style="font-size: 13px;color: #666;margin-left:10px;">建议上传图片大小2M以内</span>
          </div>
          <div class="upload-imglist" v-if="dutyImages.length > 0">
            <el-image
              class="image"
              v-for="(item, index) in dutyImages"
              :key="index"
              :src="item"
              :preview-src-list="dutyImages"
            ></el-image>
          </div> -->
        </div>
        <el-button @click="next">下一步</el-button>
        <!-- 上传多图 -->
        <!-- <el-dialog
          title="上传盖章后的责任通知书"
          :visible.sync="isShowUploadImage"
          width="820px"
          top="20vh"
        >
          <div class="upload-morewrap">
          
            <el-upload
              class="upload-demo"
              list-type="picture-card"
              :action="$Url + 'exhibitor/company/uploadFile'"
              :headers="headers"
              multiple
              name="file"
              :file-list="dutyImgs"
              :limit="5"
              :on-remove="handleRemove"
              :on-success="handlePictureSuccess"
              :class="fileLength === 5 ? 'hide-box' : ''"
            >
              <i class="el-icon-tickets"></i>
              <div class="el-upload__text">
                <p style="color: #000; font-size: 16px">上传图片</p>
                <p>最多上传5张</p>
              </div>
            </el-upload>
          </div>
          <div slot="footer" class="dialog-footer">
            <span class="footer-btn" @click="isShowUploadImage = false"
              >取消</span
            >
            <span class="footer-btn save-btn" @click="saveImage">保存</span>
          </div>
        </el-dialog> -->
        <!-- <el-dialog :visible.sync="dialogVisible" top="20vh">
          <img
            :src="dialogImageUrl"
            alt=""
            style="
              max-height: 550px;
              max-width: 100%;
              margin: 0 auto;
              display: block;
            "
          />
        </el-dialog> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDetail,
  getResources,
  saveResponsibility,
  getResponsibility,
  download,
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "dutyNotice",
  data() {
    return {
      loading: false,
      active: 9,
      headers: {},
      stepImg: require("../assets/notice_step.jpg"),
      fileIcon: require("../assets/file_img.jpg"), // pdf的图标
      content: {
        title_brief: "",
      },
      fileList: [],
      fileLength: 0,
      dutyImgs: [],
      dutyImages: [],
      dialogVisible: false, // 预览图片弹框
      dialogImageUrl: "", // 预览图片地址
      isShowUploadImage: false,
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/dutyNotice";
    });
    this.active = index;
    this.id = this.$route.query.id;
    this.getSource(this.id);
    this.getContent(this.id);
    // 获取责任保证书盖章的图片
    this.getFileImage();
    // if (this.stepMenuList[this.active].state == "finish") {
    //   this.checked = true;
    // }
    let token = this.$store.state.token;
    this.headers = {
      Authorization: token,
    };
  },
  created() {},
  methods: {
    //  获取内容
    getContent(id) {
      this.loading = true;
      getDetail({ id })
        .then((res) => {
          //console.log(res, "======菜单进度");
          this.loading = false;
          if (res.code == 200) {
            let { data } = res.data;
            this.content = data[0];
            if (data[0].step) {
              this.content.title_brief = data[0].step.title_brief;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取资源
    getSource(id) {
      getResources({ id })
        .then((res) => {
          //console.log(res, "======获取资源");
          if (res.code == 200) {
            let { data } = res.data;
            this.fileList = data.fileList;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //保存图片
    saveImage() {
      let data = this.dutyImgs;
      if (data.length == 0) {
        this.$message.warning("至少上传一张图");
        return false;
      }
      let arr = [];
      console.log(data, "=====data");
      data.forEach((item) => {
        if (item.response) {
          arr.push(item.response.data);
        } else {
          arr.push(item.url);
        }
      });
      this.dutyImages = arr;
      this.isShowUploadImage = false;
      this.save(this.dutyImages);
    },
    // 上传成功
    handleSuccess(resData, file, fileList) {
      if (resData.code === 200) {
        this.dutyImage = resData.data;
        this.save(this.dutyImage);
      }
    },
    // logo上传失败
    handleError(err, file, fileList) {
      this.$message.error(err.message);
    },
    //预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = this.$imgOssUrl + file;
      // this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 下载pdf
    down(file, name, id) {
      const IFRAME = document.createElement("iframe");
      IFRAME.style.display = "none";
      IFRAME.style.height = 0;
      IFRAME.src = this.$imgOssUrl + file;
      document.body.appendChild(IFRAME);
      if (id) {
        let data = this.$qs.stringify({
          resources: {
            resourcesid: id,
            resourcesName: name,
          },
        });
        this.upDownload(data);
      }
      setTimeout(() => {
        IFRAME.remove();
      }, 60 * 1000);
    }, // 获取责任书
    getFileImage() {
      getResponsibility()
        .then((res) => {
          //console.log(res, "======获取责任书");
          if (res.code == 200) {
            if(res.data == null){
              this.dutyImages = [];
              this.dutyImgs = [];
              return false
            }
            let data = res.data.file_imgs;
            let arr = [];
            let arrImg = [];
            data.forEach((item, index) => {
              arr.push(item.url);
              arrImg.push({
                url:item.url,
              });
            });
            this.dutyImages = arr;
            this.dutyImgs = arrImg;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }, // 保存责任书
    save(file_imgs) {
      let data = this.$qs.stringify({
        file_imgs,
      });
      saveResponsibility(data)
        .then((res) => {
          //console.log("======保存责任书");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    upDownload(data) {
      download(data)
        .then((res) => {})
        .catch((err) => {
          console.log(err);
        });
    },
    handleRemove(file, fileList) {
      // 删除图片把当前图片列表的length赋值给fileLength
      this.fileLength = file.length;
      this.dutyImgs = fileList;
    },
    handlePictureSuccess(resData, file, fileList) {
      if (resData.code === 200) {
        // 图片上传成功赋值当前列表length
        this.dutyImgs = fileList;
        this.fileLength = fileList.length;
      }
    },
    next() {
      if (this.dutyImages.length == 0) {
        this.$message.warning("请上传盖章后的责任通知书");
        return false;
      }
      
      this.active = this.active + 1;
      let { link_url, menu_title, id } = this.stepMenuList[this.active];
      if (link_url == "/exhibitorManual" || link_url == "/standPrepare") {
        this.$router.push({
          path: link_url
        });
      } else {
        this.$router.push({
          path: link_url,
        
        });
      }
    }, 
  },
};
</script>

<style lang="scss" scoped>
.zrtz{
  width:599px;
}
.te-right{
  border: 1px solid #008DFF;
    color: #2690E6;
    text-align: center;
    padding: 6px 20px;
    box-sizing: border-box;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    span{
      margin-left: 0;
    }
}
.fir_box{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 20px 30px;
  box-sizing: border-box;
  span{
    display: inline-block;
    width: 100px;
    margin-right: 20px;
    font-size: 24px;
    font-weight: 500;
  }
}
.content-pd {
  padding-bottom: 115px;
}
.notice-wrap {
  width: 100%;
  height: 504px;
  padding: 40px 70px;
  box-sizing: border-box;
  overflow-y: scroll;
  margin-top: 50px;
  background: #f2f6fb;
  border-radius: 10px;
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-track-piece {
    background-color: rgba(0, 0, 0, 0.1);
    -webkit-border-radius: 6px;
  }
  &::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    background-color: rgba(125, 125, 125, 0.3);
    -webkit-border-radius: 6px;
  }
  &::-webkit-scrollbar-thumb:horizontal {
    width: 5px;
    background-color: rgba(125, 125, 125, 0.3);
    -webkit-border-radius: 6px;
  }
}
.notice-wrap /deep/ img {
  max-width: 100%;
}
.check-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 34px;
  .el-checkbox__label {
    font-size: 20px;
    color: #3a3a3c;
    line-height: 28px;
  }
  .el-checkbox__inner {
    width: 28px;
    height: 28px;
    border-radius: 5px;
    background: #d8d8d8;
    border: 2px solid #979797;
  }
  .el-checkbox__inner::after {
    top: 5px;
    left: 10px;
    height: 10px;
    border-width: 2px;
  }
}
.duty-wrap {
  margin: 30px 0 0 0;
  padding: 30px 0;
  box-sizing: border-box;
  background: #fff;
  border-radius: 6px;
  .duty-tips {
    font-size: 18px;
    color: #2c2c2e;
    margin-bottom: 10px;
    padding-left: 40px;
    box-sizing: border-box;
  }
  .template-list{
    padding: 20px !important;
    box-sizing: border-box !important;
    height: initial !important;
    margin-left: 40px;
    margin-bottom: 15px !important;
    border: 1px dashed #c0ccda !important;
  }
  .template-list:last-child {
    margin-bottom: 0;
  }
}
.el-upload-list__item {
 
  display: flex !important;
  align-items: center;
  justify-content: center;
  transition: none !important;
  -webkit-transition: nonne !important;
}
.el-upload-list__item-name {
  transition: none !important;
  -webkit-transition: nonne !important;
}
.upload-demo,
.el-upload-list {
  display: flex;
  flex-wrap: wrap;
}
/deep/ .hide-box .el-upload--picture-card {
  display: none;
}
/deep/ .upload-duty {
 
  font-size: 18px;
  color: #2c2c2e;
  padding: 30px 30px;
  background: #fff;
  border-radius: 6px;
  margin-top: 20px;
  box-sizing: border-box;
  .edit-btn {
    cursor: pointer;
    width: 94px;
    height: 27px;
    color: #1677ff;
    font-size: 12px;
    line-height: 27px;
    text-align: center;
    background: #fff;
    border-radius: 15px;
    margin-left: 15px;
    border: 1px solid #1677ff;
    display: inline-block;
    &:hover {
      text-decoration: underline;
    }
  }
  .upload-imglist {
    display: flex;
    margin-top: 20px;
    .image {
      width: 148px;
      height: 148px;
      color: #666;
      margin-right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #c0ccda;
      border-radius: 6px;
      .el-image__inner {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
}
/deep/ .upload-morewrap {
  .el-upload--picture-card {
    width: 400px;
    height: 160px;
    line-height: 20px;
    border-radius: 8px;
    .el-icon-tickets {
      font-size: 55px;
      color: #1677ff;
      margin: 25px 0 16px;
      line-height: 50px;
    }
    .el-upload__text {
      height: auto;
      color: #999;
      font-size: 14px;
      line-height: 24px;
    }
  }
}
/deep/ .el-upload-list--picture-card {
  display: flex;
  flex-wrap: wrap;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 160px;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  
}
.upload-duty {
  font-size: 18px;
  color: #2c2c2e;
  padding-top: 30px;
  .avatar-uploader {
    width: 384px;
    height: 152px;
    overflow: hidden;
    background: #fff;
    border-radius: 8px;
    margin-top: 10px;
    border: 1px dashed #bfbfbf;
    /deep/ .el-upload {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .add-wrap {
      line-height: 25px;
      color: #8c8c8c;
      font-size: 12px;
      .title {
        color: #434343;
        font-size: 16px;
      }
      .el-icon-document {
        font-size: 40px;
        color: #1677ff;
        margin: 20px auto 10px;
      }
    }
    .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      max-width: 384px;
      max-height: 152px;
      display: block;
    }
    .upload-img {
      .upload-span {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba($color: #000, $alpha: 0.4);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: all 0.1s;
        .upload-icon {
          color: #fff;
          font-size: 28px;
        }
      }
      &:hover {
        .upload-span {
          opacity: 1;
        }
      }
    }
  }
}
/deep/ .el-dialog__footer {
  .footer-btn {
    font-size: 14px;
    cursor: pointer;
    color: #606266;
    padding: 12px 20px;
    border-radius: 4px;
    display: inline-block;
    border: 1px solid #dcdfe6;
  }
  .save-btn {
    color: #fff;
    margin-left: 10px;
    border-color: #409eff;
    background-color: #409eff;
  }
}
@media only screen and (max-width: 1280px) {
  .fir_box span{
    margin-bottom: 15px !important;
  }
}

@media only screen and (max-width: 767px) {
  .content{
    padding: 30px 0 130px 0;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 100px !important;
    height: 100px !important;
  }
  .content .el-button {
    font-size: 15px !important;
  }
  .file-time {
    font-size: 12px !important;
    margin-top: 2px !important;
}
 .file-num {
    margin-top: 2px !important;
 
}
.te-right{
  padding: 4px 14px !important;
}
.file-icon{
  margin-right: 16px !important;
}
.duty-tips{
  width: 92% !important;
  font-size:14px !important;
  line-height:20px !important;
}
.fir_box{
  padding: 20px 23px !important;
}

  .file-name{
    font-size: 16px !important;
    line-height: 22px !important;
  }
  .content{
    width: 100%;
  //   padding: initial !important;
    margin: initial !important;
  }
  .duty-wrap{
    width: 90%;
    margin: 30px auto;
  }
  .upload-duty{
    width: 90%;
    margin: auto;
  }
  .template-list{
    width: 90% !important;
    margin-left: 20px !important;
  }
  .zrtz{
  width:100% !important;
}
.fir_box span{
  font-size: 18px!important;
  margin-bottom: 20px!important;
}

}
</style>
<style>
@media only screen and (max-width: 767px) {
  .el-upload-list--picture-card .el-upload-list__item {
    width: 110px!important;
    height: 110px!important;
}
.upload-morewrap .el-upload--picture-card {
     width: 228px!important;
    height: 150px!important;
}
}
</style>